import type { FieldPath, FieldValues } from "react-hook-form";

import type { BaseInputProps } from "@/shared/types";
import { TextInput } from "./TextInput";

export function EmailInput<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  props: BaseInputProps<TFieldValues, TName>
) {
  return <TextInput {...props} type="email" placeholder={props.placeholder ?? "Enter email"} />;
}
